import { de, enUS, ru } from 'date-fns/locale'

export const LANGUAGE = {
  DE: 'de',
  EN: 'en',
}

export const LANGUAGES = new Set(Object.values(LANGUAGE))

export const TIME_ZONE = {
  FUNAFUTI: 'Pacific/Funafuti',
  VIENNA: 'Europe/Vienna',
  YUKON: 'Canada/Yukon',
}

export const TIME_ZONES = new Set(Object.values(TIME_ZONE))

export const LOCALE = {
  DE: de,
  EN_US: enUS,
  RU: ru,
}

export const LOCALES = new Set(Object.values(LOCALE))
